import { TagsList } from "../../../../../Tags/List"
import { Helmet } from "react-helmet-async"

export default function TripsTagsPage() {
	return (
		<>
			<Helmet>
				<title>Trip Tags</title>
			</Helmet>
			<TagsList scope="trips" />
		</>
	)
}
